import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ja from 'vee-validate/dist/locale/ja.json'
import en from 'vee-validate/dist/locale/en.json'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'ja',
  fallbackLocale: 'ja',
  silentTranslationWarn: process.env.NODE_ENV === 'production',
  messages: {
    ja: {
      validation: ja.messages,
      ...require('../locales/ja.json'),
    },
    en: {
      validation: en.messages,
      ...require('../locales/en.json'),
    },
  },
})

export { i18n }
